import type {ConferenceApiModel} from '../../../api/conference';
import type {CoreCoachConferencesStartParams} from '../../../api/types/core/methods';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {conferenceStore} from '../../../api/conference';
import {isConferenceStarted} from '../../../utils/entity/conference';
import {isMeCoachForEntity} from '../../../utils/entity/isMeCoachForEntity';
import {AppError} from '../../../utils/errors/app';
import {logger} from '../../../utils/logger';
import {conferenceJoin} from './conference.join';

export {conferenceStart};

type Config = BaseConfig<Omit<CoreCoachConferencesStartParams, '_id'>> & {
  entity: ConferenceApiModel;
};

const strategy: AsyncStrategy = async (roles, config) => {
  return isMeCoachForEntity((config as Config).entity)
    ? roles.coach(config)
    : roles.client(config);
};

async function conferenceStart(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

conferenceStart.asClient = asClient;
conferenceStart.asCoach = asCoach;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({entity, params}: Config) {
  try {
    if (isConferenceStarted(entity)) {
      return await conferenceJoin.asCoach({entity, params});
    }

    const result = await conferenceStore.coach.start(entity, params);

    return result;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
